/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect, useRef } from 'react';
import AnimalType from '../../../../../enums/animal-type';
import { useHistory, useParams } from 'react-router-dom';
import { useService } from '../../../../../services/services';
import { route } from '../../../../../services/utils';
import { LIVESTOCK_ANIMALS_SEPARATION_VIEW } from '../../../../../router/routes';
import { SubmitType } from '../../../../../components/form';
import { FormMode } from '../../../../../enums/form-mode';
import { StatusMedicines } from './enums/enums';
import { AnimalEventAnimal } from '../../../../../interfaces/animal-event';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { addNotice } from '../../../../../store/global-slice';
import { of } from 'rxjs';
import { useQuery } from '../../../../../hooks/use-query';

export function useSeparationUpdate(animals: AnimalEventAnimal[]) {
  const { farmId, id } = useParams<{
    farmId: string;
    id: string;
  }>();
  const [queries] = useQuery();

  const history = useHistory();
  const { animalEventService } = useService();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const allAnimlas = useRef(transformAnimal(animals));
  const allAnimlasNames = useRef(transformAnimalsNames(animals));

  useEffect(() => {
    allAnimlas.current = transformAnimal(animals);
    allAnimlasNames.current = transformAnimalsNames(animals);
  }, [animals]);

  const transformProducts = (products) => {
    const productData = [];

    products.map((p) => {
      p.barns.map((barn) => {
        productData.push({
          id: p.id ? p.id : null,
          product_category_id: p.product_category_id.value,
          product_type_id: p.product_type_id.value,
          product_id: p.product_id.value,

          amount_for_one: barn.amount_for_one,
          warehouse_id: barn.barn_id.value,
          product_amount_for_one: barn.product_amount_for_one.amount,
          product_amount_total: barn.product_amount_total,
          product_unit: barn.product_unit.value,
        });
      });
    });

    return productData;
  };

  return useCallback<SubmitType<any>>((data) => {
    if (allAnimlas.current.length === 0) {
      dispatch(
        addNotice({
          accessor: 'EditForm',
          status: 'error',
          description: t(
            'pages.livestock.animals_and_events.animals.no_animal'
          ),
        })
      );
      return [of(null)];
    } else {
      const formData = {
        type: AnimalType.separation,
        sub_type: data.event_type,
        status: data.status,
        animals: allAnimlas.current,
        extra_data: {
          medicines_status: data.medicines_status,
          meat_restrictions_date_from: data.meat_restrictions_date_from
            ? new Date(data.meat_restrictions_date_from).toLocaleDateString('en-CA')
            : '',
          meat_restrictions_date_to: data.meat_restrictions_date_to
            ? new Date(data.meat_restrictions_date_to).toLocaleDateString('en-CA')
            : '',
          milk_restrictions_date_from: data.milk_restrictions_date_from
            ? new Date(data.milk_restrictions_date_from).toLocaleDateString('en-CA')
            : '',
          milk_restrictions_date_to: data.milk_restrictions_date_to
            ? new Date(data.milk_restrictions_date_to).toLocaleDateString('en-CA')
            : '',
          birth_weight: data.birth_weight,
          recorded_weight: data.recorded_weight,
          growth: data.growth,
        },
        date: data.date,
        products:
          data.medicines_status === StatusMedicines.yes && data.products
            ? transformProducts(data.products)
            : null,
        notes: data.notes,
        file_id: data.file[0]?.id,
        purpose_and_place_of_use: allAnimlasNames.current.join(','),
      };

      return [
        animalEventService.update(farmId, id, formData),
        (response) => {
          history.push(
            route(
              `${LIVESTOCK_ANIMALS_SEPARATION_VIEW}${
                queries.to ? '?to='.concat(queries.to) : ''
              }`,
              {
                farmId,
                id: response.data.id,
                mode: FormMode.view,
              }
            )
          );
        },
      ];
    }
  }, []);
}

export const transformAnimal = (animals) =>
  animals.map(({ animal_event_animal_id, id }: AnimalEventAnimal) => ({
    animal_event_animal_id,
    id,
  }));

export const transformAnimalsNames = (animals) =>
  animals.map((animal: AnimalEventAnimal) => animal.animal_id);
